import Component from '@cwp/component'

export default class Pagination extends Component {
  init() {
    const baseUrl = window.location.href.replace(
      /\/?(page\/\d+\/?)?(\?.+)?$/,
      ''
    )
    const queryString = window.location.search || ''
    const pageChangeForms = [
      ...this.element.querySelectorAll('.pagination-changePageForm'),
    ]

    if (pageChangeForms.length) {
      for (const form of pageChangeForms) {
        form.addEventListener('submit', (event) => {
          const input = event.target.querySelector('input')

          window.location.assign(`${baseUrl}/page/${input.value + queryString}`)
          event.preventDefault()
        })
      }
    }
  }
}
